import axios from "./axios";
import { AxiosReturn } from "./types";
import * as Requests from "./requests";
import { IBranch } from "../types/shared";

export const addBranch = (token, data): AxiosReturn<IBranch> => {
  return axios.post(Requests.branches, data, {
    headers: {
      token,
    },
  });
};
